<script>
import { CARD_ART_HEIGHT } from '../ui/art';

export default {
  name: 'ArtAlreadyProcessed',
  data() {
    return {
      CARD_ART_HEIGHT
    };
  }
};
</script>

<template>
  <img src="/add-to-transcript/art-success.png" :height="CARD_ART_HEIGHT" alt="Already processed" />
</template>
